import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { Button, NumberInput, Select, Stack } from "@mantine/core";
import { randomId } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { isNumber } from "lodash";
import { useState } from "react";
import {
  RegisterCustomTeamsInput,
  TournamentTeamStatus,
} from "../../../../../gql/graphql";

export const GenerateRandomTeamsModal = ({
  tournamentId,
}: {
  tournamentId: string;
}) => {
  const [loading, setLoading] = useState(false);
  const [teamsCount, setTeamsCount] = useState(1);
  const [members, setMembers] = useState(1);
  const [teamStatus, setTeamStatus] = useState<TournamentTeamStatus>(
    TournamentTeamStatus.Registered,
  );
  const [registerCustomTournamentTeams] = useMutation<
    {
      registerCustomTournamentTeams: { id: string };
    },
    { tournamentId: string; input: RegisterCustomTeamsInput }
  >(gql`
    mutation ($tournamentId: ID!, $input: RegisterCustomTeamsInput!) {
      registerCustomTournamentTeams(
        tournamentId: $tournamentId
        input: $input
      ) {
        id
      }
    }
  `);

  return (
    <Stack>
      <NumberInput
        label="Teams count"
        min={1}
        max={100}
        value={teamsCount}
        onChange={(value) => setTeamsCount(isNumber(value) ? value : 1)}
      />
      <NumberInput
        label="Team members"
        min={1}
        max={5}
        value={members}
        onChange={(value) => setMembers(isNumber(value) ? value : 1)}
      />
      <Select
        label="Team status"
        data={Object.values(TournamentTeamStatus)}
        value={teamStatus}
        onChange={(value) => setTeamStatus(value as TournamentTeamStatus)}
      />
      <Button
        loading={loading}
        onClick={() => {
          setLoading(true);
          registerCustomTournamentTeams({
            variables: {
              tournamentId,
              input: {
                customTeams: Array.from({ length: teamsCount }).map(
                  (_, idx) => ({
                    name: `Team ${idx + 1} - ${randomId()}`,
                    tag: `T${idx + 1}`,
                    customFields: [],
                    status: teamStatus,
                    members: Array.from({ length: members }).map(
                      (_, memberIdx) => ({
                        player: {
                          customFields: [],
                          description: "Generated player",
                          username: `Team ${idx + 1} - ${
                            memberIdx + 1
                          } - ${randomId()}`,
                        },
                      }),
                    ),
                  }),
                ),
              },
            },
          })
            .then((data) => {
              if (data?.error) {
                throw new Error(data.error.message);
              }
              modals.closeAll();
            })
            .finally(() => {
              setLoading(false);
            });
        }}
      >
        Generate
      </Button>
    </Stack>
  );
};
